import { render, staticRenderFns } from "./PcScrollingPromptsItem.vue?vue&type=template&id=0f30326b"
import script from "./PcScrollingPromptsItem.vue?vue&type=script&lang=js"
export * from "./PcScrollingPromptsItem.vue?vue&type=script&lang=js"
import style0 from "./PcScrollingPromptsItem.vue?vue&type=style&index=0&id=0f30326b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports